<template>
  <div class="status-alerts">
    <!-- :class="'alert '+alert.type" -->
    <!-- :class="['alert', alert.type, { blink: alert.blink }]" -->
    <span
      v-for="alert in alerts"
      :key="alert.id"
      :class="'alert '+(alert.type?alert.type:'alert-info-text')+' blink'"
    >
      <strong>{{ alert.title }}</strong> <strong v-if="alert.message">- {{ alert.message }}</strong>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    SUBS_alerts: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      alerts: this.SUBS_alerts,
      // [
      //   {
      //     id: 1,
      //     type: 'danger',
      //     title: 'Red Sea Movements Stopped',
      //     message: 'Maersk has stopped all movements in the Red Sea for 48 hours. This decision comes after the Maersk Hangzhou was hit by a missile at approximately 5:30 PM GMT on Saturday, 4 nautical miles southwest of Al Hodeidah, Yemen.'
      //   },
      //   {
      //     id: 2,
      //     type: 'warning',
      //     title: 'Shipping Ban',
      //     message: 'Malaysia bans all Israeli and Israel-bound ships starting today. The Prime Minister of Malaysia will take immediate action by imposing a permanent ban on the company effective immediately.'
      //   }
      //   // Add more alerts as needed
      // ]
    };
  },

  methods: {
    startBlinking() {
      // Function to start blinking for a certain duration
      this.alerts.forEach((alert) => {
        alert.blink = true;
        setTimeout(() => {
          alert.blink = false;
        }, 2000); // Adjust the duration as needed (2000ms = 2 seconds)
      });
    },
  },

  watch: {
    SUBS_alerts(newAlerts) {
      // Watch for changes in the alerts prop
      this.alerts = newAlerts;
      this.startBlinking();
    }
  }
};
</script>

<style scoped>
.status-alerts {
  font-size:18px;
  /* display: flex; */
  flex-direction: column;
  /* margin-bottom: 20px; */
}

.alert {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  color: #fff;
}

.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
    color: #d9534f; /* Bootstrap danger color */
}

.alert-info-text {
  color: #2a6fde;
  /* background-color: #2a6fde; Bootstrap danger color */
}

.alert-warning {
  background-color: #f0ad4e; /* Bootstrap warning color */
}

.alert strong {
  margin-right: 5px;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s infinite; /* Adjust the duration as needed */
}
</style>



// WEBPACK FOOTER //
// StatusAlerts.vue?3e8044c4